export const isSSR = () => __SERVER__ ?? false;

export const getAggSubscriptionEndpoint = () =>
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	`${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;
